import { toScrollTop } from '@/utils/utils'

export const formAfterActionRegister = async () => {
  toScrollTop(500, 450, formAfterActionRegister)
}
